export interface IFormattedDate {
    day: string;
    month: string;
    year: string;
}

export const formatDateFromString = (date: string): IFormattedDate => {
    const dateFormatted = new Date();
    dateFormatted.setFullYear(
        parseInt(`20${date.substr(0, 2)}`, 10),
        parseInt(date.substr(2, 2), 10) - 1,
        parseInt(date.substr(4, 2), 10)
    );

    const day = `0${dateFormatted.getDate()}`.slice(-2);
    const month = `0${dateFormatted.getMonth() + 1}`.slice(-2);
    const year = dateFormatted.getFullYear().toString();

    return {
        day,
        month,
        year
    };
};
